import { FeatureConfig } from '../facades';

export const provideFeatureConfig = () => {
  return [FeatureConfig];
};
